import React, { Fragment, useEffect, useState } from 'react';

import KycModal from './modal/KycModal';
import config from './config';
import { getClientKyc } from '../../services/kyc';
import { navigate } from '../../services/web.navigation';
import firstModalAcceptButtonTag from './tagging/firstModalAcceptButtonTag';
import firstModalCancelButtonTag from './tagging/firstModalCancelButtonTag';
import modalLoadTag from './tagging/modalLoadTag';

const Kyc = () => {
  if (!config.isActive) {
    return <Fragment />;
  }
  const [toggleModal, setToggleModal] = useState(false);

  useEffect(() => {
    /* istanbul ignore next */
    const timer = setTimeout(async () => {
      const showModal = await getClientKyc();
      setToggleModal(showModal);
      if (showModal) {
        modalLoadTag(parent.session.SESSION.rut);
      }
      const modalInicial = window.parent.document.querySelector('#modalinicial');
      if (modalInicial) {
        modalInicial.style.zIndex = 12;
      }
    }, 20000);
    return () => clearTimeout(timer);
  }, []);

  const goForm = () => {
    navigate('#mfe/mfe-kyc-web-cl/');
  };

  const handleCloseModal = () => {
    setToggleModal(false);

    firstModalCancelButtonTag(parent.session.SESSION.rut);
  };

  const handleAcceptForm = () => {
    firstModalAcceptButtonTag(parent.session.SESSION.rut);
    goForm();
  };

  return (
    <Fragment>
      {toggleModal && (
        <KycModal
          closeModal={handleCloseModal}
          handleAccept={handleAcceptForm}
          title={config.modal.title}
          body={config.modal.body}
        />
      )}
    </Fragment>
  );
};

export default Kyc;
